
import { Component, Inject, InjectReactive, Prop, Vue, Watch } from 'vue-property-decorator';
@Component({})
export default class RadioItem extends Vue {
  @Prop() value?: string;
  @InjectReactive('selectedValue') selectedValue!: string;
  @Inject() formId!: string;
  @Inject() selectItem!: (value: string | undefined) => void;

  get inputId() {
    return `${this.formId}-${this.value}`;
  }

  get isChecked() {
    return this.selectedValue === this.value;
  }

  get radioClasses() {
    return {
      'radio-item': true,
      'radio-selected': this.selectedValue === this.value,
    };
  }

  public onRadioChange(event: Event) {
    event.preventDefault();
    this.selectItem(this.value);
  }
}
